import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {API_URL, trackEntityById} from 'projects/core/src/public-api';
import {Task} from '../../../../../data/tasks/task';
import {TasksService} from '../../../../../data/tasks/tasks.service';
import {MatDialog} from '@angular/material/dialog';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {
  ImageGalleryCarouselComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/image-gallery-carousel/image-gallery-carousel.component';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {FileUpload} from 'primeng/fileupload';
import {FileService} from '../../../../../../../../../../core/src/lib/misc/data/file/file.service';
import {
  FileOpenerService
} from '../../../../../../../../../../app-misc/src/app/modules/project-misc/utils/fileOpener.service';

export class FilesObj {
  taskFiles?: ProjectFile[]
  files?: File[]
}


@Component({
  selector: 'app-task-files',
  templateUrl: './task-files.component.html',
  styleUrls: ['./task-files.component.scss']
})
export class TaskFilesComponent implements OnInit, OnDestroy {

  @Input()
  task: Task;

  taskFiles: ProjectFile[] = []
  files: File[] = []

  @Output()
  newFilesEmit = new EventEmitter<FilesObj>()

  progressBar: number;

  @Input()
  projectId: number;

  trackEntityById = trackEntityById;

  loadingSpinner = false;

  @ViewChild('filesForm', {static: false})
  filesForm: FileUpload;

  filePasteListener = null;

  constructor(
    protected dialog: MatDialog,
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected tasksService: TasksService,
    private snackBarService: MiscSnackBarService
  ) {
  }

  ngOnInit(): void {
    if (this.task && this.task.id) {
      this.loadingSpinner = true;
      this.tasksService.getFiles(this.task.id).subscribe(files => {
        this.task.files = files;
        this.taskFiles = this.task.files
        this.loadingSpinner = false;
      })
    }

    this.filePasteListener = (event: ClipboardEvent) => {
      const items = (event.clipboardData).items;
      const fileArray = [];

      // tslint:disable-next-line: forin
      for (const index in items) {
        const item = items[index];
        if (item.kind === 'file') {
          const file = item.getAsFile();
          fileArray.push(file)
        }
      }

      if (fileArray.length) {
        this.uploadFile(fileArray)
      }
    }

    document.addEventListener('paste', this.filePasteListener);
  }

  uploadFile(files: File[], filesForm?) {


    if (this.task && this.task.id) {
      const fileArray = [];

      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < files.length; i++) {
        fileArray.push(files[i])
      }
      this.uploadFileRequest(fileArray, filesForm)
    } else {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < files.length; i++) {
        this.taskFiles.push({
          id: null,
          name: files[i].name
        })
        this.files.push(files[i])
      }
      this.newFilesEmit.emit({
        taskFiles: this.taskFiles,
        files: this.files
      })
    }

    filesForm?.clear();
  }

  uploadFileRequest(fileArray, filesForm?) {
    this.tasksService.uploadFile(fileArray, this.task.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3


      } else if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.task.files = this.task.files.concat(projectFiles)
        this.taskFiles = this.task.files
        this.progressBar = 0
      }

      filesForm?.clear();
    }, error => {
      this.loadingSpinner = false
      this.snackBarService.openErrorSnackBar(error.message)
      this.progressBar = 0;
    })
  }

  deleteFile(file: ProjectFile) {
    if (this.task && this.task.id) {
      this.tasksService.deleteFile(file.id, this.task.id).subscribe(() => {
        const index = this.task.files.indexOf(file, 0);
        if (index > -1) {
          this.task.files.splice(index, 1);
          this.taskFiles = this.task.files
        }
      })
    } else {
      const index = this.taskFiles.indexOf(file, 0);
      if (index > -1) {
        this.taskFiles.splice(index, 1);
        this.files.splice(index, 1);
        this.newFilesEmit.emit({
          taskFiles: this.taskFiles,
          files: this.files
        })
      }
    }

  }

  openFile(projectFile: ProjectFile) {
    if (this.task && this.task.id) {
      this.fileOpenerService.openFile(projectFile, this.task.files, true)
    }
  }

  getIcon(ext: string) {
    return this.fileService.getIcon(ext)
  }

  getTinyIcon(fileId: number) {
    return this.fileService.getImageThumbNail(fileId)
  }

  chooseFile() {
    this.filesForm.choose()
  }

  ngOnDestroy() {
    document.removeEventListener('paste', this.filePasteListener)
  }
}
